import PlusIcon from '../../../assets/icons/plus.svg?react';
import MasterCardIcon from '../../../assets/icons/mastercard.svg?react';
import DeksIcon from '../../../assets/icons/deks-logo-filled.svg?react';
import styled, { useTheme } from 'styled-components';

const PrepaidCardContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  background: linear-gradient(0deg, #a1a1a1, #eeeeee);
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const MasterCardContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  bottom: 5%;
  right: 5%;
`;

const CardTypeText = styled.p`
  font-size: 6px;
  font-weight: 500;
  color: black;
`;

const CardText = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: #85888f;
`;

const DeksContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  top: 5%;
  left: 5%;
`;

const PrepaidCard = ({ showTapToReveal = true }) => {
  const theme = useTheme();

  return (
    <PrepaidCardContainer>
      <DeksContainer>
        <DeksIcon width={20} color={'black'} />
      </DeksContainer>
      <MasterCardContainer>
        <CardTypeText>PREPAID</CardTypeText>
        <MasterCardIcon width={40} color={'black'} style={{ marginTop: -4 }} />
      </MasterCardContainer>
      {showTapToReveal && <CardText>Tap to reveal details</CardText>}
    </PrepaidCardContainer>
  );
};

export default PrepaidCard;
